export const QUERY_PARAMS = {
    SALE_YEAR: 'saleYear',
    SALE_NUMBER: 'saleNumber',
    LANE_NUMBER: 'laneNumber',
    LINK: 'link'
}